<template>
  <ValidationObserver v-if="internalClasse.id" ref="classeObserver">
    <BookmarkCard :tag-type="tagType" :icon-name="iconName">
      <template #content>
        <div>
          <div v-if="classeAdded">
            <SelectWithValidation
              v-if="!readOnly"
              v-model="enseignement"
              :label="$t('projetPage.infoAdministratives.classe.enseignement')"
              :data="enseignements"
              :select-labels="enseignementsLabels"
              rules="required"
              :vid="'validation-to-ignore_nouvelle_classe_enseignement_' + internalClasse.id"
              @update:model-value="enseignementChanged()"
            />
            <SelectWithValidation
              v-if="enseignement === 'ELEMENTAIRE' && !readOnly"
              v-model="type"
              :label="$t('projetPage.infoAdministratives.classe.type')"
              :data="types"
              :select-labels="typesLabels"
              rules="required"
              :disabled="readOnly"
              :vid="'classe_type_' + internalClasse.id"
            />

            <!-- WARNING : it's a vee-validate hack -->
            <div class="vee-validate-hack">
              <InputWithValidation
                v-if="!isNbNiveauValid && !readOnly"
                :vid="'classe_type_niveaux_' + internalClasse.id"
                rules="niveauValid"
              />
            </div>
            <span
              v-if="
                enseignement === 'COLLEGE' || enseignement === 'LYCEE' || type !== '' || readOnly
              "
              >{{ $t("projetPage.infoAdministratives.classe.effectifs") }}</span
            >
            <div v-if="enseignement === 'ELEMENTAIRE' ? Boolean(type) : Boolean(enseignement)">
              <div v-for="eleves in Object.keys((cursus as any)[enseignement] || {})" :key="eleves">
                <CheckBoxEntry
                  v-if="!readOnly || (internalClasse as any)[eleves]"
                  :vid="
                    'validation-to-ignore_nouvelle_classe_nb_' +
                    ((cursus as any)[enseignement] ? (cursus as any)[enseignement][eleves] : '') +
                    '_' +
                    internalClasse.id
                  "
                  :is-checked="Boolean((internalClasse as any)[eleves])"
                  :entry-label="
                    $t(
                      'projetPage.infoAdministratives.classe.niveauxLabels.' +
                        ((cursus as any)[enseignement]
                          ? (cursus as any)[enseignement][eleves]
                          : ''),
                    )
                  "
                  :extra-input1-placeholder="
                    $t('projetPage.infoAdministratives.classe.nb-placeholder')
                  "
                  :extra-input1-value="(internalClasse as any)[eleves] || null"
                  :disabled="
                    readOnly ||
                    (niveau.length !== 0 &&
                      isNbNiveauValid &&
                      (cursus as any)[enseignement] &&
                      niveau.indexOf((cursus as any)[enseignement][eleves]) === -1 &&
                      type !== 'MULTI')
                  "
                  extra-input1-rule="max_value:50"
                  :hide-extras-until-checked="true"
                  @checked="
                    (checked) =>
                      (cursus as any)[enseignement] &&
                      modifyClasse(checked, (cursus as any)[enseignement][eleves])
                  "
                  @input-1="
                    (value) => {
                      ;(internalClasse as any)[eleves] = value ? parseInt(value) : null
                    }
                  "
                />
              </div>
            </div>
            <CheckBoxEntry
              v-if="
                ((enseignement === 'ELEMENTAIRE' ? Boolean(type) : enseignement) && !readOnly) ||
                Boolean(internalClasse.eleves_autre1)
              "
              :vid="'validation-to-ignore_nouvelle_classe_nb_autre_' + internalClasse.id"
              :is-checked="Boolean(internalClasse.eleves_autre1)"
              :extra-input1-placeholder="$t('projetPage.infoAdministratives.classe.nb-placeholder')"
              :extra-input1-value="
                internalClasse.eleves_autre1 !== null ? internalClasse.eleves_autre1 : 0
              "
              :entry-label="$t('projetPage.infoAdministratives.classe.niveauxLabels.AUTRE')"
              :entry-input-value="internalClasse.autre1"
              :entry-input-placeholder="
                $t('projetPage.infoAdministratives.classe.autre-placeholder')
              "
              :disabled="
                readOnly ||
                (niveau.length !== 0 &&
                  isNbNiveauValid &&
                  niveau.indexOf('AUTRE') === -1 &&
                  type !== 'MULTI')
              "
              extra-input1-rule="max_value:50"
              :hide-extras-until-checked="true"
              @checked="(checked) => modifyClasse(checked, 'AUTRE')"
              @input-1="
                (value) => {
                  ;(internalClasse as any).eleves_autre1 = value ? parseInt(value) : 0
                }
              "
              @entry-input="
                (value) => {
                  internalClasse.autre1 = value
                }
              "
            />

            <!-- Only to display old classes with autre2 values -->
            <CheckBoxEntry
              v-if="Boolean(internalClasse.eleves_autre2)"
              :vid="'validation-to-ignore_nouvelle_classe_nb_autre_' + internalClasse.id"
              :is-checked="Boolean(internalClasse.eleves_autre2)"
              :extra-input1-placeholder="$t('projetPage.infoAdministratives.classe.nb-placeholder')"
              :extra-input1-value="internalClasse.eleves_autre2 || undefined"
              :entry-label="$t('projetPage.infoAdministratives.classe.niveauxLabels.AUTRE')"
              :entry-input-value="internalClasse.autre2"
              :entry-input-placeholder="
                $t('projetPage.infoAdministratives.classe.autre-placeholder')
              "
              :disabled="true"
              extra-input1-rule="max_value:50"
              :hide-extras-until-checked="true"
              @checked="(checked) => modifyClasse(checked, 'AUTRE')"
              @input-1="
                (value) => {
                  internalClasse.eleves_autre2 = value ? parseInt(value) : 0
                }
              "
              @entry-input="
                (value) => {
                  internalClasse.autre2 = value
                }
              "
            />
          </div>
          <p v-else>
            <br />{{ $t("projetPage.infoAdministratives.classe.description") }}<br /><br />
          </p>
        </div>
      </template>
      <template #footer>
        <div class="classe-footer">
          <b-button
            v-if="!classeAdded"
            type="is-primary is-outlined"
            rounded
            @click="classeAdded = true"
          >
            {{ $t("create") }}
          </b-button>
          <b-button
            v-if="!readOnly && classeAdded"
            type="is-primary is-outlined"
            rounded
            :disabled="!enseignement || (enseignement === 'ELEMENTAIRE' && !type)"
            @click="addClasse"
          >
            {{ $t("add") }}
          </b-button>
          <b-button
            v-if="canDelete"
            type="is-danger is-outlined"
            rounded
            icon-left="trash"
            @click="deleteClasse()"
          >
            {{ $t("delete") }}
          </b-button>
        </div>
      </template>
    </BookmarkCard>
  </ValidationObserver>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import BookmarkCard from "../generic_components/BookmarkCard.vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import SelectWithValidation from "@/views/inputs/SelectWithValidation.vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import { CURSUS, ENSEIGNEMENTS, TAG_TYPES_FOR_BOOKMARK_CARD } from "@/model/bean/EnumHelper"
import { ClasseDTO, ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import CheckBoxEntry from "../inputs/CheckBoxEntry.vue"
import { BButton } from "buefy"

export default defineComponent({
  name: "ClasseCard",
  components: {
    BookmarkCard,
    InputWithValidation,
    SelectWithValidation,
    ValidationObserver,
    CheckBoxEntry,
    BButton,
  },
  props: {
    classe: {
      type: Object as PropType<ClasseDTO>,
      required: false,
      default: undefined,
    },
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },

  emits: ["add", "delete"],
  data() {
    return {
      classeAdded: false,
      infoReportingService: InfoReportingService.INSTANCE,
      tagType: TAG_TYPES_FOR_BOOKMARK_CARD.NOUVELLE_CLASSE,
      readOnly: false,
      iconName: "plus",
      internalClasse: Object.assign(new ClasseDTO(), { id: "temp-" + Date.now() }),
      enseignement: "",
      type: "",
      niveau: [] as string[],
      enseignements: ENSEIGNEMENTS,
      enseignementsLabels: [] as string[],
      types: ["SIMPLE", "DOUBLE", "MULTI"],
      typesLabels: [] as string[],
      cursus: CURSUS,
      isNbNiveauValid: false,
    }
  },
  computed: {},
  watch: {
    projetAnnuel(): void {
      requestAnimationFrame(() => {
        const observer = this.$refs.classeObserver as InstanceType<typeof ValidationObserver>
        if (observer && observer.reset) {
          observer.reset()
        }
      })
    },
    classe(): void {
      this.classeChanged()
    },
  },
  created(): void {
    this.enseignementsLabels = this.enseignements.map((value) => {
      return this.$t(`projetPage.infoAdministratives.classe.enseignementLabels.${value}`).toString()
    })
    this.typesLabels = this.types.map((value) => {
      return this.$t(`projetPage.infoAdministratives.classe.typesLabels.${value}`).toString()
    })
  },
  mounted(): void {
    this.classeChanged()
    if (this.classe) {
      this.readOnly = true
      this.tagType = TAG_TYPES_FOR_BOOKMARK_CARD.CLASSE
      this.iconName = "users"
    } else {
      this.readOnly = false
      this.tagType = TAG_TYPES_FOR_BOOKMARK_CARD.NOUVELLE_CLASSE
      this.iconName = "plus"
    }
  },
  methods: {
    enseignementChanged(): void {
      this.reinitElevesNumbersIfEdition()
    },

    reinitElevesNumbersIfEdition(): void {
      if (this.classe) {
        return
      }

      this.enseignements.map((enseignement: string) =>
        //@ts-ignore
        Object.keys(this.cursus[enseignement]).map((niveau) => {
          //@ts-ignore

          if (this.internalClasse[niveau]) {
            //@ts-ignore
            this.internalClasse[niveau] = null
          }
        }),
      )

      this.internalClasse.autre1 = ""
      ;(this.internalClasse as any).eleves_autre1 = 0
    },

    reinitClasseElevesNumber(niveauToEmpty: string): void {
      if (this.classe) {
        return
      }

      this.enseignements.map((enseignement: string) =>
        //@ts-ignore
        Object.entries(this.cursus[enseignement]).map(([niveau, niveauLabel]) => {
          //@ts-ignore
          if (niveauLabel == niveauToEmpty && this.internalClasse[niveau]) {
            //@ts-ignore
            ;(this.internalClasse as any)[niveau] = null
          }
        }),
      )

      if (niveauToEmpty == "AUTRE") {
        this.internalClasse.autre1 = ""
        ;(this.internalClasse as any).eleves_autre1 = 0
      }
    },

    addClasse(): void {
      // Assigner les niveaux à internalClasse
      this.internalClasse.niveaux = [...this.niveau]

      this.classeAdded = false
      this.$emit("add", this.internalClasse)

      // reset values
      this.classeChanged()
      this.enseignement = ""
      this.type = ""
      this.niveau = []
    },

    deleteClasse(): void {
      this.infoReportingService.dialog(
        this.$t("confirmation").toString(),
        this.$t("projetPage.infoAdministratives.classe.are-you-sure").toString(),
        this.$t("projetPage.infoAdministratives.classe.delete").toString(),
        () => {
          this.$emit("delete", this.classe)
        },
        "is-info",
      )
    },

    setNbNiveauValid(): void {
      this.isNbNiveauValid =
        (this.type === "DOUBLE" && this.niveau.length === 2) ||
        (this.type === "MULTI" && this.niveau.length >= 3) ||
        ((this.type === "SIMPLE" || !this.type) && this.niveau.length === 1)
    },

    modifyClasse(add: boolean, classeNiveau: string): void {
      if (add) {
        this.niveau.push(classeNiveau)
      } else {
        const index = this.niveau.indexOf(classeNiveau)
        if (index !== -1) {
          this.niveau.splice(index, 1)
          this.reinitClasseElevesNumber(classeNiveau)
        }
      }
      this.setNbNiveauValid()
      // this.emitModifyClasse()
    },

    classeChanged(): void {
      if (this.classe) {
        this.classeAdded = true
        this.internalClasse = this.classe
        // @ts-ignore
        this.internalClasse.id =
          // @ts-ignore
          this.classe.id || this.internalClasse.id
      } else {
        this.internalClasse = new ClasseDTO()
        this.internalClasse.id = "new-" + (this.projetAnnuel.classes.length + 1)
      }
      this.niveau = []

      this.enseignements.map((enseignement) => {
        //@ts-ignore
        Object.keys(this.cursus[enseignement]).map((niveau) => {
          //@ts-ignore
          const elevesForNiveau = this.internalClasse[niveau]
          if (elevesForNiveau) {
            this.enseignement = enseignement
            //@ts-ignore
            this.niveau.push(this.cursus[enseignement][niveau])
          }
        })
      })

      if (this.internalClasse.eleves_autre1) {
        this.niveau.push("AUTRE")
      }

      this.type = ""
      if (this.enseignement === "ELEMENTAIRE") {
        const nbNiveaux = this.niveau.length
        if (nbNiveaux === 1) {
          this.type = "SIMPLE"
        } else if (nbNiveaux === 2) {
          this.type = "DOUBLE"
        } else if (nbNiveaux >= 3) {
          this.type = "MULTI"
        }
      }
      this.enseignementChanged()
      this.setNbNiveauValid()
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

$classe-card-width: 250px;

.BookmarkCard {
  &.classe,
  &.nouvelle-classe {
    height: auto;
    margin-left: 10px;
    margin-right: 10px;

    .BookmarkCard-tag,
    .BookmarkCard-icon {
      background-color: $ofb-bleu-1;
    }

    .BookmarkCard-content {
      height: auto;
      width: $classe-card-width - 20px;
      padding-left: 10px;
      padding-right: 10px;
      align-items: baseline;

      .mandatory {
        display: none;
      }

      .SelectWithValidation-field {
        width: $classe-card-width - 20px;
      }

      span {
        font-weight: bold;
      }
    }

    .BookmarkCard-card {
      height: auto;
      width: $classe-card-width;
    }

    .BookmarkCard-tag {
      width: 120px;
      text-align: center;
      height: 50px;
      text-transform: none;
      font-size: 15px;
    }

    .BookmarkCard-icon {
      width: 120px;
      color: $ofb-vert-1;
    }

    .BookmarkCard-footer {
      height: 50px;
      margin: auto;

      .classe-footer {
        margin: auto;
      }
    }

    .invisible-input {
      .label,
      .InputWithValidation-control-container {
        display: none;
      }
    }
  }
}

.effectif {
  .InputWithValidation-field {
    display: flex;
    width: $classe-card-width - 20px;

    .InputWithValidation-control-container {
      margin-right: 5px;
    }

    .InputWithValidation-fieldLabel {
      margin-right: 5px;
      margin-left: 5px;
    }
  }
}
</style>
